import felulnezetImage from '../img/felulnezet.png';
import etkezesKenyelemImage from '../img/etkezeskenyelem.png';

export const DAILY_LIFE_SECTION_TITLE = 'Élet a Napvirág Otthonban';

/** Caption patterns per slide index for social-feed photo matching */
export const DAILY_LIFE_SLIDE_PATTERNS = [
  /program|közösség|ünnep|zene|foglalkoz|koncert|névnap|karácson|farsang/i,
  /gondoz|ápoló|biztonság|egészség|orvos|ellátás/i,
  /apartman|szoba|belső|kert|épület|otthon/i,
  /étkezés|ebéd|vacsora|konyha|menü|reggeli|uzsonna/i,
];

export const HOME_STATS = [
  { id: 'years', value: '20+', label: 'év tapasztalat', hint: '2006 óta Budakalászon' },
  { id: 'apartments', value: '123', label: 'apartman', hint: 'Akadálymentes, napfényes' },
  { id: 'programs', value: 'Napi', label: 'programok', hint: 'Közösségi és kulturális' },
  { id: 'care', value: '24/7', label: 'gondoskodás', hint: 'Folyamatos segítség' },
  { id: 'spaces', value: 'Közös', label: 'tereink', hint: 'Étterem, könyvtár, tornaterem' },
  { id: 'access', value: 'Teljes', label: 'akadálymentesség', hint: 'Kényelmes mindennapok' },
];

export const DAY_TIMELINE = [
  { time: '08:00', label: 'Reggeli', icon: '🍽️' },
  { time: '10:00', label: 'Torna', icon: '🏃' },
  { time: '12:00', label: 'Ebéd', icon: '🥗' },
  { time: '14:00', label: 'Közös program', icon: '🎭' },
  { time: '16:00', label: 'Kávézás', icon: '☕' },
  { time: '18:00', label: 'Vacsora', icon: '🍲' },
];

export const HOMEPAGE_LIFE_SLIDES = [
  {
    id: 'community',
    label: 'Közösségi élet',
    title: 'Programok és közös élmények',
    description:
      'Minden héten közös programok, kulturális események, beszélgetések és könnyű foglalkozások várják lakóinkat.',
    bullets: [
      'Zenés délutánok',
      'Kreatív foglalkozások',
      'Ünnepi események',
      'Könnyű mozgásprogramok',
    ],
    ctaLabel: 'Programok megtekintése',
    ctaPath: '/naptar',
    className: 'daily-life-slide--community',
    imageLabel: 'Közösségi program',
  },
  {
    id: 'care',
    label: 'Biztonság',
    title: 'Gondoskodás minden nap',
    description:
      'Munkatársaink a nap 24 órájában figyelmet, támogatást és biztonságot nyújtanak lakóink számára.',
    bullets: [
      '24/7 segítség',
      'Személyes odafigyelés',
      'Egészségügyi támogatás',
      'Rendszeres szűrések',
    ],
    ctaLabel: 'Tudjon meg többet rólunk',
    ctaPath: '/informaciok/magunkrol',
    className: 'daily-life-slide--care',
    imageLabel: 'Gondoskodás',
  },
  {
    id: 'home',
    label: 'Otthon',
    title: 'Kényelmes apartmanok',
    description:
      'Akadálymentes apartmanjaink nyugodt, otthonos környezetet biztosítanak — lakóink saját térrel élhetnek.',
    bullets: [
      'Saját apartman',
      'Nyugodt környezet',
      'Világos, napfényes terek',
      'Saját bútorok hozhatók',
    ],
    ctaLabel: 'Apartmanok megtekintése',
    ctaPath: '/informaciok/apartmanok',
    className: 'daily-life-slide--home',
    imageLabel: 'Apartmanok',
    staticImage: felulnezetImage,
  },
  {
    id: 'meals',
    label: 'Mindennapok',
    title: 'Étkezés és kényelem',
    description:
      'Friss alapanyagokból készült napi menük és teljes körű szolgáltatások segítik a kényelmes mindennapokat.',
    bullets: [
      'Napi ötszöri étkezés',
      'Változatos menük',
      'Közös terek és szolgáltatások',
      'Diétás étrendek',
    ],
    ctaLabel: 'Heti étlap',
    ctaPath: '/heti-etlap',
    className: 'daily-life-slide--meals',
    imageLabel: 'Étkezés',
    staticImage: etkezesKenyelemImage,
  },
];

export const FEATURED_PROGRAM_FALLBACKS = [
  { title: 'Zenés délután', tag: 'Közösségi' },
  { title: 'Kreatív foglalkozás', tag: 'Kulturális' },
  { title: 'Kerti program', tag: 'Szabadtéri' },
  { title: 'Ünnepi esemény', tag: 'Ünnepség' },
];

export const PROGRAM_CAPTION_PATTERN =
  /program|foglalkoz|ünnep|zene|koncert|kert|névnap|karácson|farsang|születésnap|torna|közösség/i;

/** Assign one distinct social-feed photo per daily-life slide (4 slots). */
export function assignDailyLifeSlidePhotos(items) {
  const photos = (Array.isArray(items) ? items : []).filter((item) => item.imageUrl);
  const slotCount = DAILY_LIFE_SLIDE_PATTERNS.length;
  const slots = Array(slotCount).fill(null);
  if (!photos.length) return slots;

  const used = new Set();
  const take = (photo) => {
    if (!photo || used.has(photo.id)) return false;
    used.add(photo.id);
    return true;
  };

  DAILY_LIFE_SLIDE_PATTERNS.forEach((pattern, slideIndex) => {
    for (const photo of photos) {
      if (used.has(photo.id)) continue;
      const cap = (photo.caption || '').toLowerCase();
      if (pattern.test(cap) && take(photo)) {
        slots[slideIndex] = photo;
        break;
      }
    }
  });

  const fallbackOffsets = [0, 8, 16, 24];
  for (let slide = 0; slide < slotCount; slide += 1) {
    if (slots[slide]) continue;
    const start = fallbackOffsets[slide] ?? slide * 8;
    for (let i = start; i < photos.length; i += 1) {
      if (take(photos[i])) {
        slots[slide] = photos[i];
        break;
      }
    }
  }

  for (let slide = 0; slide < slotCount; slide += 1) {
    if (!slots[slide]) {
      const photo = photos.find((p) => !used.has(p.id)) || photos[slide % photos.length];
      if (photo && take(photo)) slots[slide] = photo;
    }
  }

  return slots;
}
